// /admin/subscription-plans CRUD-Wrapper — Owner-only (siehe api/src/routes/admin.ts).
// Abo-Pläne (monatliche Credit-Allowance + Stripe-gebundene Preise). Preise +
// Stripe-Price-IDs sind read-only — sie hängen an den Stripe-Produkten.

import { apiFetch } from './api';

export interface SubscriptionPlanRow {
  id: string;
  name: string;
  credits_per_month: number;
  price_monthly_cents: number;
  price_yearly_cents: number;
  stripe_price_monthly: string | null;
  stripe_price_yearly: string | null;
  /** SQLite-Integer: 1 = aktiv, 0 = inaktiv. */
  active: number;
  sort_order: number;
  updated_at: string | null;
}

export async function listSubscriptionPlans(
  accessToken: string,
): Promise<SubscriptionPlanRow[]> {
  return apiFetch<SubscriptionPlanRow[]>('/admin/subscription-plans', { accessToken });
}

export interface UpdateSubscriptionPlanInput {
  name?: string;
  credits_per_month?: number;
  active?: boolean;
  sort_order?: number;
}

export interface UpdateSubscriptionPlanResponse {
  ok: boolean;
  id: string;
}

export async function updateSubscriptionPlan(
  accessToken: string,
  id: string,
  input: UpdateSubscriptionPlanInput,
): Promise<UpdateSubscriptionPlanResponse> {
  return apiFetch<UpdateSubscriptionPlanResponse>(
    `/admin/subscription-plans/${encodeURIComponent(id)}`,
    {
      method: 'PUT',
      accessToken,
      json: input,
    },
  );
}
